import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleSignIn = () => {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        if (data.twofa_required) {
          window.history.replaceState(null, "", "/login");
          navigate("/login", { replace: true, state: { challengeId: data.challenge_id } });
          toast.info("This account uses two-step sign-in — enter the code we emailed you");
          return;
        }
        localStorage.setItem("uu_token", data.access_token);
        window.history.replaceState(null, "", "/dashboard");
        await refresh();
        toast.success(data.new_account ? `Welcome, ${data.user.name}` : `Welcome back, ${data.user.name}`);
        navigate("/dashboard", { replace: true });
      } catch (err) {
        toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Google sign-in failed");
        window.history.replaceState(null, "", "/login");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div data-testid="auth-callback" className="flex min-h-screen items-center justify-center bg-[#F7F8FA]">
      <p className="text-sm text-slate-500">Signing you in…</p>
    </div>
  );
}
